import { Title } from '../../atoms/title/Title';
import { Grid } from '@mui/material';
import logo from '../../../assets/eemdl-logo.png';
import { modelSettings } from '../../../settings/settings';
import ReactDOM from 'react-dom';
import { useEffect, useRef, useState } from 'react';

export const Header = ({
  modelName,
  tabsPortal,
}: {
  modelName: string;
  tabsPortal?: React.ReactNode;
}) => {
  const currentModelSettings = modelSettings[modelName];

  const portalContainerRef = useRef<HTMLDivElement | null>(null);

  const [isPortalReady, setIsPortalReady] = useState(false);

  useEffect(() => {
    if (portalContainerRef.current) {
      setIsPortalReady(true);
    }
  }, [portalContainerRef.current]);

  return (
    <>
      <Grid
        container
        spacing={3}
        padding={2}
        alignItems={'top'}
        justifyItems={'center'}
        justifyContent={'space-between'}
      >
        <Grid item xs={1} sm={1}>
          <img
            src={logo}
            alt="logo"
            style={{ maxWidth: '150px', marginTop: '5px' }}
            width={'100%'}
          />
        </Grid>
        <Grid item xs={4} sm={4} alignItems={'top'} marginRight={'auto'}>
          <Title title={currentModelSettings.title} />
        </Grid>
        <Grid
          item
          xs={6}
          sm={6}
          alignItems={'top'}
          style={{
            maxWidth: '100%',
            flexBasis: currentModelSettings.isContentMenuEnabled
              ? 'auto'
              : '50%',
          }}
        >
          <div
            ref={portalContainerRef}
            style={{
              marginLeft: 'auto',
              display: 'flex',
              alignItems: 'center',
              marginRight: '0',
              marginTop: '-10px',
            }}
          ></div>
        </Grid>
        <Grid item xs={12} sm={12}>
          <div
            dangerouslySetInnerHTML={{
              __html: currentModelSettings.description || '',
            }}
          />
        </Grid>
      </Grid>
      {currentModelSettings &&
        currentModelSettings.isContentMenuEnabled &&
        tabsPortal &&
        isPortalReady &&
        portalContainerRef.current &&
        ReactDOM.createPortal(tabsPortal, portalContainerRef.current)}
    </>
  );
};
